<script>
	import { setUserToken } from '../store/user';

	setUserToken();
</script>

<div>
	Loading...
</div>

<style lang="scss">

</style>
